 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTTITLE_PAGE from '@/components/Text/title_page'
 import LOVE_1 from '@/components/love_1'
 import TEXT003TITLE from '@/components/Text/003title'
 import TEXT004COPYRIGHT from '@/components/Text/004copyright'
 import TEXT008PART1 from '@/components/Text/008part1'
 import TEXT009CHAP01 from '@/components/Text/009chap01'
 import TEXT010CHAP02 from '@/components/Text/010chap02'
 import TEXT011CHAP03 from '@/components/Text/011chap03'
 import TEXT012CHAP04 from '@/components/Text/012chap04'
 import TEXT013CHAP05 from '@/components/Text/013chap05'
 import TEXT014PART02 from '@/components/Text/014part02'
 import TEXT015CHAP06 from '@/components/Text/015chap06'
 import TEXT016CHAP07 from '@/components/Text/016chap07'
 import LOVE_2 from '@/components/love_2'
 import TEXTCHAP154320 from '@/components/Text/chap154320'
 import TEXTCHAP154321 from '@/components/Text/chap154321'
 import TEXTCHAP159682 from '@/components/Text/chap159682'
 import TEXTCHAP149284 from '@/components/Text/chap149284'
 import TEXTCREDITS from '@/components/Text/credits'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/title_page",
 			"name" : "Text/title_page",
 			"component" : TEXTTITLE_PAGE
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/Text/003title",
 			"name" : "Text/003title",
 			"component" : TEXT003TITLE
 		},
 		{
 			"path" : "/Text/004copyright",
 			"name" : "Text/004copyright",
 			"component" : TEXT004COPYRIGHT
 		},
 		{
 			"path" : "/Text/008part1",
 			"name" : "Text/008part1",
 			"component" : TEXT008PART1
 		},
 		{
 			"path" : "/Text/009chap01",
 			"name" : "Text/009chap01",
 			"component" : TEXT009CHAP01
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js